/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sitemap': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M14.27 4.524H9.8v4.472h4.471V4.524zm-8.288 9.632h.47c.128 0 .234-.127.234-.283v-1.556h4.89v1.556c0 .156.105.283.234.283h.47c.129 0 .234-.127.234-.283v-1.556h4.869v1.61c0 .156.105.282.234.282h.47c.128 0 .234-.126.234-.282V11.55v-.005l-.001-.002v-.076c0-.157-.106-.283-.235-.283h-5.572V9.628c0-.155-.105-.283-.234-.283h-.47c-.129 0-.234.126-.234.283v1.557H5.988c-.13 0-.235.126-.235.283v.101a.12.12 0 01-.002.015c-.002.007-.003.013-.003.02v2.27c-.001.155.104.282.234.282zm3.817.848h4.471v4.472H9.8v-4.472zm-1.327 0H4v4.472h4.472v-4.472zm7.057 0h4.472v4.472h-4.472v-4.472z" _fill="#B1ADC2"/>'
  }
})
